<div class="row rms-tree-item-picker">
  <div class="col-xs-12 col-md-6">
    <div class="form-group">
      <label for="treePickerFilter">{{filterLabel}}</label>
      <input type="text" id="treePickerFilter" (input)="filter($event.target.value)"
             class="form-control" [placeholder]="searchPlaceholder">
    </div>
    <div class="rms-tip-list bordered-box">
      <ul *ngIf="convertedItems.length > 0">
        <li *ngFor="let item of convertedItems">
          <div class="checkbox">
            <input type="checkbox" [disabled]="item.children && item.children.length > 0"
                   [id]="'parent' + item.id" [name]="'parent' + item.id"
                   [checked]="item.isChecked"
                   (change)="itemChanged(item)">
            <label [for]="'parent' + item.id"
                   (click)="(item.children && item.children.length > 0) ? toggleCollapse(item) : null"
                   [ngClass]="{'is-parent': item.children && item.children.length > 0}">
              <i class="fa fa-angle-{{item.expanded ? 'down' : 'right'}}" aria-hidden="true"
                 *ngIf="item.children"></i>
              {{item.label}}
            </label>
          </div>
          <!--Child list-->
          <ul *ngIf="item.children && item.children.length > 0" [hidden]="!item.expanded">
            <li *ngFor="let subItem of item.children">
              <div class="checkbox">
                <input type="checkbox" [id]="'child' + subItem.id" [name]="'child' + subItem.id"
                       (change)="itemChanged(subItem)">
                <label [for]="'child' + subItem.id">{{subItem.label}}</label>
              </div>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
  <div class="col-xs-12 col-md-6">
    <span class="fake-label">{{selectedListLabel}} ({{itemsAdded.length}})</span>
    <div class="rms-tip-selected-items bordered-box">
      <ul>
        <li *ngFor="let item of itemsAdded" (click)="removeSelectedItem(item)">{{item.label}}</li>
      </ul>
    </div>
  </div>
  <div class="col">
    <button type="button" class="btn btn-primary" (click)="addCheckedItems()">
      {{selectedListLabel}} ({{itemsChecked.length}})
    </button>
  </div>
</div>
